import React, { useState } from 'react';
import { ConfirmationDialog, CustomModal } from '../ui';
import { PencilIcon, TrashIcon } from '../../icons';
import AddEditDriver from './addEditDriver';

const EditDriverView = ({
  selectedDriver,
  handleAddMultipleDrivers,
  handleAssignCar,
  setSelectedDriver,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openDriverModal, setOpenDriverModal] = useState(false);

  const [openDeletionModal, setDeletionOpenModal] = useState(false);
  const { id, firstName, lastName, birthDate, driversLicense } =
    selectedDriver || {};

  const handleDeleteDriver = () => {};

  return (
    <>
      <CustomModal
        blurred={false}
        triggerClass="flex items-center justify-center"
        triggerComponent={
          <div className="h-[1px] w-[60px] bg-fadedgrey self-center"></div>
        }
        handleClick={(value) => setOpenModal(value)}
        openModal={openModal}
        disabled={!id}
        wrapperClass="max-lg:h-full"
      >
        <div className="container-sm mx-auto gap-4 flex flex-col lg:py-10 py-5 max-lg:px-5">
          <div className="flex flex-col gap-3">
            <button
              type="button"
              className="self-center"
              onClick={() => setOpenModal(false)}
            >
              <div className="h-[1px] w-[60px] bg-fadedgrey "></div>
            </button>
            <div className="flex justify-between">
              <h3 className="text-center">Στοιχεία οδηγού</h3>
              <CustomModal
                triggerComponent={
                  <div className="flex items-center gap-3">
                    <span className="text-primary-button text-primary">
                     Επεξεργασία
                    </span>
                    <PencilIcon className="stroke-primary" />
                  </div>
                }
                wrapperClass="max-lg:h-full"
                handleClick={(value) => setOpenDriverModal(value)}
                openModal={openDriverModal}
              >
                <AddEditDriver
                  setOpenModal={setOpenDriverModal}
                  driversDetails={selectedDriver}
                  setSelectedDriver={setSelectedDriver}
                  mode="edit"
                  handleAddMultipleDrivers={() => {
                    setOpenDriverModal(false);
                    setOpenModal(false);
                    handleAddMultipleDrivers();
                  }}
                />
              </CustomModal>
            </div>
          </div>
          <div className="flex flex-col gap-10 p-5 border border-fadedgrey rounded-lg">
            <DriverDetails selectedDriver={selectedDriver} />
            <div className="flex flex-col gap-3">
              <CustomModal
                triggerClass={`flex items-center justify-center btn-secondary flex gap-2 w-full ${
                  id ? 'border-primary' : 'border-fadedgrey'
                }`}
                triggerComponent={
                  <>
                    <TrashIcon color={!id ? '#a5a5a5' : '#D4002A'} />
                    <span className={'text-primary-button text-primary'}>
                      Διαγραφή Οδηγού
                    </span>
                  </>
                }
                handleClick={(value) => setDeletionOpenModal(value)}
                openModal={openDeletionModal}
                disabled={!id}
              >
                <div className="container-sm mx-auto lg:py-10">
                  <ConfirmationDialog
                    message={
                      `Είσαι σίγουρος ότι θέλεις να διαγράψεις οριστικά τον/την ${firstName} ${lastName} από τη συνολική λίστα οδηγών;`
                    }
                    title="Διαγραφή Οδηγού"
                    handleOkClick={handleDeleteDriver}
                    isLoading={false}
                    handleCancelClick={() => setDeletionOpenModal(false)}
                  />
                </div>
              </CustomModal>

              <button
                type="button"
                disabled={!id}
                className="btn-secondary text-secondary-button w-full"
                onClick={() => {
                  setOpenModal(false);
                  handleAssignCar();
                }}
              >
                Προσθήκη αυτοκινήτου
              </button>
            </div>
          </div>
        </div>
      </CustomModal>
      <h4>
        {firstName} {lastName}
      </h4>
      <div className="flex items-center gap-2">
        <div className="flex gap-1">
          <span className="text-label text-fadedgrey">Αριθμός διπλώματος:</span>
          <span className="text-label">{driversLicense}</span>
        </div>
        <div className="flex gap-1">
          <span className="text-label text-fadedgrey">Ημερομηνία γέννησης:</span>
          <span className="text-label">{birthDate && birthDate.split('-')[2]+'/'+birthDate.split('-')[1]+'/'+birthDate.split('-')[0]}</span>
        </div>
      </div>
    </>
  );
};

const DriverDetails = ({ selectedDriver }) => {
  const {
    firstName,
    lastName,
    email,
    phone,
    birthDate,
    driversLicense,
    driversLicenseExpirationDate,
    driversLicenseIssueDate,
  } = selectedDriver || {};
  return (
    <div className="grid gap-y-3">
      <div className="flex justify-between">
        <h6>Όνομα:</h6>
        <div className="text-body">{firstName}</div>
      </div>
      <div className="flex justify-between">
        <h6>Email:</h6>
        <div>{email}</div>
      </div>
      <div className="flex justify-between">
        <h6>Αριθμός διπλώματος::</h6>
        <div>{driversLicense}</div>
      </div>
      <div className="flex justify-between">
        <h6>Ημερ/νία λήξης διπλώματος:</h6>
        <div>{driversLicenseExpirationDate}</div>
      </div>
      <div className="flex justify-between">
        <h6>Επώνυμο:</h6>
        <div>{lastName}</div>
      </div>
      <div className="flex justify-between">
        <h6>Ημερομηνία γέννησης:</h6>
        <div>{!!birthDate ? birthDate.split('-')[2]+'/'+birthDate.split('-')[1]+'/'+birthDate.split('-')[0] : '-'}</div>
      </div>
      <div className="flex justify-between">
        <h6>Ημερ/νία έκδοσης διπλώματος:</h6>
        <div>{!!driversLicenseIssueDate ? driversLicenseIssueDate.split('-')[2]+'/'+driversLicenseIssueDate.split('-')[1]+'/'+driversLicenseIssueDate.split('-')[0] : '-'}</div>
      </div>
      <div className="flex justify-between">
        <h6>Αριθμός τηλεφώνου:</h6>
        <div>{phone}</div>
      </div>
    </div>
  );
};

export default EditDriverView;
